import _ from 'lodash'
// import { QRCodeSVG as QRCode } from 'qrcode.react'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../button'
import { useModal } from '../../hook/use-modal'
// import combineClassNames from '../../helpers/combineClassNames'
import IconDialogLink from '../../assets/images/icon-dialog-link.png'
import IconDialogLink2x from '../../assets/images/icon-dialog-link@2x.png'
import IconDialogLink3x from '../../assets/images/icon-dialog-link@3x.png'
import IconDialogSend from '../../assets/images/icon-dialog-send.png'
import IconDialogSend2x from '../../assets/images/icon-dialog-send@2x.png'
import IconDialogSend3x from '../../assets/images/icon-dialog-send@3x.png'
import IconDialogWhatsapp from '../../assets/images/icon-dialog-whatsapp.png'
import IconDialogWhatsapp2x from '../../assets/images/icon-dialog-whatsapp@2x.png'
import IconDialogWhatsapp3x from '../../assets/images/icon-dialog-whatsapp@3x.png'
import useStyles from './token-button-style'

function TokenButtonView(props) {
  const {
    disabled,
    countDown,
    countDownInProgress,
    loading,
    qrCodeValue,
    type,
    onContinue,
    onDismiss,
    ...rest
  } = props
  const modal = useModal()
  const { t } = useTranslation()
  const styles = useStyles()

  let labelTranslationKey = 'ui.emailTokenButton.label'
  if (type === 'phone') {
    labelTranslationKey = 'ui.smsTokenButton.label'
  }
  if (type === 'whatsapp') {
    labelTranslationKey = 'ui.whatsappTokenButton.label'
  }

  useEffect(() => {
    if (!_.isEmpty(qrCodeValue)) {
      modal.open({
        title: t('ui.whatsappTokenButton.whatsappTokenVerificationRedirectModal.title'),
        className: styles.whatsappTokenVerificationRedirectModal,
        contentComponent: (
          <div className={styles.contentContainer}>
            <div
              className={styles.instructions}
              dangerouslySetInnerHTML={{
                __html: t(
                  'ui.whatsappTokenButton.whatsappTokenVerificationRedirectModal.instructionsHtml',
                  {
                    iconWhatsappImgSrc: IconDialogWhatsapp,
                    iconWhatsappImgSrc2x: IconDialogWhatsapp2x,
                    iconWhatsappImgSrc3x: IconDialogWhatsapp3x,
                    iconLinkImgSrc: IconDialogLink,
                    iconLinkImgSrc2x: IconDialogLink2x,
                    iconLinkImgSrc3x: IconDialogLink3x,
                    iconSendImgSrc: IconDialogSend,
                    iconSendImgSrc2x: IconDialogSend2x,
                    iconSendImgSrc3x: IconDialogSend3x,
                  },
                ),
              }}
            />
          </div>
        ),
        buttons: [
          {
            text: t('ui.whatsappTokenButton.whatsappTokenVerificationRedirectModal.buttons.continue'),
            onClick: onContinue,
            className: styles.continueButton,
          },
          {
            text: t('ui.whatsappTokenButton.whatsappTokenVerificationRedirectModal.buttons.dismiss'),
            onClick: onDismiss,
          },
        ],
      })
    } else {
      modal.close()
    }
  }, [qrCodeValue])

  return (
    <Button
      disabled={countDownInProgress || disabled || loading}
      text={t(labelTranslationKey, {
        count: countDown,
        context: countDown <= 0 ? '0' : '1', // FL: added context to i18n key since i18next's Plural function doesn't work.
      })}
      {...rest}
    />
  )
}

export default TokenButtonView
